export default __webpack_public_path__ + "static/media/price-1000.42d19b0a.png";